<template>
  <div id="divFeedWrapper">
    <div :style="backgroundStyle">
      <div class="content-layout-fixer">
        <div class="insider" id="inStory"></div>
        <div class="ad-wrapper-large">
          <div id="div-gpt-ad-1587046762079-0"></div>
        </div>
        <BrandContentSlider swiperId="mainSliderFeed" />
        <MultiBannerSlider
          @onClickSliderContent="onClickSliderContent"
          @onSubSliderChanged="onSubSliderChanged"
          @initSubSlider="initSubSlider"
        />
        <br /><br />
        <hr />
        <div v-if="categories && categories.length">
          <div v-for="(category, index) in categories" :key="index">
            <BrandContentList
              v-if="category.feeds"
              :contents="category.feeds"
              :title="category.name"
              :id="`observer_${category.id}_${index}`"
              :showButton="category.continue"
              @showMoreClicked="showMore(category)"
              :eventTitle="`Anasayfa / ${category.name}`"
            ></BrandContentList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrandContentList from '@/components/brand/BrandContentList/BrandContentList';
import BrandContentSlider from '@/components/brand/Slider/BrandContentSlider.vue';
import MultiBannerSlider from '@/components/brand/Slider/MultiBannerSlider.vue';
import { Common, Content, StaticContent } from '@/services/Api/index';
import gtmUtils from '@/mixins/gtmUtils.js';
import StorageProps from '@/mixins/storageProps.js';
import { mapGetters } from 'vuex';
import { STATIC_CONTENT_KEYS } from '@/constants/staticContent.constants';
const FALLBACK_BACKGROUND_IMAGE = require('@/assets/bg/bg-image.png');
import RoutesRoot from '@/router/routes/RoutesRoot.js';
import RoutesSecure from '@/router/routes/RoutesSecure';

export default {
  name: 'Feed',
  mixins: [StorageProps, gtmUtils],
  components: {
    BrandContentList,
    BrandContentSlider,
    MultiBannerSlider,
  },
  data() {
    return {
      contentTypes: [],
      categories: [],
      mainSlider: [],
      viewed_promotions: [],
      mainPageBackgroundImage: null,
    };
  },
  computed: {
    ...mapGetters('app', ['getLastPosition']),
    ...mapGetters('auth', ['getUserDetails']),
    backgroundStyle() {
      if (!this.isPartner || this.mainPageBackgroundImage === null) return '';

      return {
        background: `url('${this.mainPageBackgroundImage}')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        backgroundSize: '100% 650px',
      };
    },
  },
  methods: {
    fetchBackgroundImage() {
      StaticContent.getStaticContent(STATIC_CONTENT_KEYS.MAIN_PAGE_BACKGROUND)
        .then(res => {
          if (res.data?.Data?.content) {
            this.mainPageBackgroundImage = res.data.Data.content;
          } else {
            this.mainPageBackgroundImage = FALLBACK_BACKGROUND_IMAGE;
          }
        })
        .catch(error => {
          console.error('Failed to fetch main page background image:', error);
          this.mainPageBackgroundImage = FALLBACK_BACKGROUND_IMAGE;
        });
    },
    getFeedFilters() {
      Content.getFeedFilters().then(res => {
        if (
          res.data &&
          res.data.Data &&
          res.data.Data.contentTypes &&
          res.data.Data.contentTypes.length > 0
        ) {
          const {
            Data: { contentTypes },
          } = res.data;
          this.$store.dispatch('app/setContentTypes', contentTypes);
          this.contentTypes = contentTypes;
          const contentTypeIds = this.contentTypes.map(item => item.contentTypeId);
          Common.getAllFeeds(contentTypeIds).then(res => {
            if (res.data && res.data.Data) {
              const {
                Data: { feedAll },
              } = res.data;
              feedAll.forEach((item, index) => {
                let newItem = {
                  continue: item.isFeedContinue,
                  feeds: item.feeds,
                  name: this.contentTypes[index].contentName,
                  id: this.contentTypes[index].contentTypeId,
                  startIndex: 3,
                  index: index,
                };
                this.categories.push(newItem);
              });
              this.categories = this.categories.sort(function(a, b) {
                return a.index - b.index;
              });
              this.$store.dispatch('app/setCategories', this.categories);
            }
          });
          setTimeout(() => {
            window.scrollTo(0, this.getLastPosition);
          }, 500);
        }
      });
    },
    onClickSliderContent(banner) {
      this.pushDataLayerEvent('clickContent', banner);
      this.pushDataLayerEvent('ecommerce');
      this.pushDataLayerEvent('select_promotion', {
        creative: 'Subbanner',
        bannerId: banner.bannerId,
        title: banner.title,
        link: banner.link,
      });
    },
    initSubSlider(banners) {
      let mappedEventData = [];

      banners.forEach(banner => {
        if (!this.viewed_promotions.includes(banner.bannerId)) {
          this.pushDataLayerEvent('ecommerce');
          this.pushDataLayerEvent('view_promotion', {
            creative: 'Subbanner',
            bannerId: banner.bannerId,
            title: banner.title,
            link: banner.link,
          });
          this.viewed_promotions.push(banner.bannerId);
        }
        mappedEventData.push({
          id: banner.bannerId,
          name: banner.title,
          creative: banner.imageURL,
          position: banner.position,
        });
      });

      this.pushDataLayerEvent('changedContent', mappedEventData);
    },
    onSubSliderChanged(banner) {
      this.pushDataLayerEvent('changedContent', {
        id: banner.bannerId,
        name: banner.title,
        creative: banner.imageURL,
        position: banner.position,
      });
      if (!this.viewed_promotions.includes(banner.bannerId)) {
        this.pushDataLayerEvent('ecommerce');
        this.pushDataLayerEvent('view_promotion', {
          creative: 'Subbanner',
          bannerId: banner.bannerId,
          title: banner.title,
          link: banner.link,
        });
        this.viewed_promotions.push(banner.bannerId);
      }
    },
    showMore(category) {
      this.$router.push(
        `${RoutesRoot.Secure.path}/${RoutesSecure.Fun.path}?contentTypeId=${category.id}`,
      );
    },
    onIframeClick() {
      this.pushDataLayerEvent('videoPlayerStart', {
        videoPlayerStart: true,
        customerCode: this.getUserDetails?.customer_code,
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('app/setLastPosition', window.scrollY);
    next();
  },
  mounted() {
    this.fetchBackgroundImage();
    this.getFeedFilters();
    let isClicked = false;
    let onClick = () => {
      this.onIframeClick();
    };
    var eventListener = window.addEventListener('blur', function() {
      if (!isClicked && document.activeElement === document.getElementById('iframe')) {
        isClicked = true;
        onClick();
        setTimeout(function() {
          window.focus();
        }, 0);
      }
      window.removeEventListener('blur', eventListener);
    });
    //initialize google ads for homepage
    this.pushAds('large');

    var storyDiv = document.querySelector('#inStory');
    if (storyDiv) {
      document.body.addEventListener('click', event => {
        if (storyDiv.contains(event.target)) {
          this.pushDataLayerEvent('story');
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
/deep/ .content-card-list {
  margin: 0;
}
.player-iframe {
  max-width: 1025px;
  height: 573px;
  width: 1025px;
  margin-bottom: 15px;
}
</style>
